/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_In_DeliveryInputs */

const vi_status_order_in_delivery = /** @type {(inputs: Status_Order_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giao`)
};

/**

* @param {Status_Order_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_in_delivery = /** @type {((inputs?: Status_Order_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_in_delivery(inputs)
});